<template>
  <BasePopup ref="popup" title="Kindle settings integration">
    <div class="book-export__image-wrapper">
      <img
        class="book-export__settings-screenshot"
        src="@/assets.app/images/kindle-settings-desktop.png"
      />
    </div>
    <div class="book-export__image-wrapper">
      <img
        class="book-export__settings-screenshot-mobile"
        src="@/assets.app/images/kindle-settings-mobile.png"
      />
    </div>
  </BasePopup>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import BasePopup from '@/components/ui/BasePopup.vue'

const popup = useTemplateRef('popup')

function show(): void {
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

defineExpose({
  show,
  hide,
})
</script>
